import React, { createContext, useState, useEffect, useCallback } from "react";

export const FlashContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export function FlashProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("flash-panel-open");
    } else {
      document.body.classList.remove("flash-panel-open");
    }
    return () => document.body.classList.remove("flash-panel-open");
  }, [isOpen]);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <FlashContext.Provider value={{ isOpen, open, close }}>
      {children}
    </FlashContext.Provider>
  );
}
